module.exports = __webpack_public_path__ + "img/smartcam-long.b7e8c229.png";